// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/risk_calc_engine_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's risk_calc_engine_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { CollateralConfig, PayReceive } from "./common_model_pb";
import { file_devtool_emodel_v1_common_model } from "./common_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/risk_calc_engine_model.proto.
 */
export const file_devtool_emodel_v1_risk_calc_engine_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_common_model, file_google_type_date]);

/**
 * 日次マーケットデータ
 *
 * @generated from message devtool.emodel.v1.RiskCalcMarketData
 */
export type RiskCalcMarketData = Message<"devtool.emodel.v1.RiskCalcMarketData"> & {
  /**
   * 日次MTM値
   *
   * @generated from field: repeated double daily_mtms = 1;
   */
  dailyMtms: number[];

  /**
   * 日次固定電力コスト（nil対応）
   *
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_fixed_power_costs = 2;
   */
  dailyFixedPowerCosts: DailyPowerCostEntry[];

  /**
   * 日次変動電力コスト（nil対応）
   *
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_unfixed_power_costs = 3;
   */
  dailyUnfixedPowerCosts: DailyPowerCostEntry[];

  /**
   * 日次JEPX差額コスト
   *
   * @generated from field: repeated double daily_jepx_difference_costs = 4;
   */
  dailyJepxDifferenceCosts: number[];

  /**
   * 日次キャッシュIO（入出金）
   *
   * @generated from field: repeated double daily_cash_ios = 5;
   */
  dailyCashIos: number[];

  /**
   * Floating現在価格（floating_index_code -> price）
   *
   * @generated from field: map<string, double> floating_current_prices = 6;
   */
  floatingCurrentPrices: { [key: string]: number };
};

/**
 * Describes the message devtool.emodel.v1.RiskCalcMarketData.
 * Use `create(RiskCalcMarketDataSchema)` to create a new message.
 */
export const RiskCalcMarketDataSchema: GenMessage<RiskCalcMarketData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 0);

/**
 * ポジションデータ
 *
 * @generated from message devtool.emodel.v1.RiskCalcTradeData
 */
export type RiskCalcTradeData = Message<"devtool.emodel.v1.RiskCalcTradeData"> & {
  /**
   * メインポジションデータ（BG/EEX用、PnLCalculator構築用）
   *
   * 空を許す。eModel は空の main_positions を受け付けて PFE 0 と入出金だけで
   * 計算し、流動性 PFE のバッチも「約定はあるがネット後のポジションが空
   * （受渡済み・未決済の品代だけが残る）」のポートフォリオをそのまま送っている。
   * BFF の protovalidate だけが min_items = 1 で弾くと dev-tool の
   * 本番ベースの計算が通らないので、ここでは制約を付けない（service-proto 側も
   * 同じ変更を入れる）。
   *
   * @generated from field: repeated devtool.emodel.v1.PositionEntry main_positions = 1;
   */
  mainPositions: PositionEntry[];

  /**
   * JEPXポジションデータ（JEPX用、JEPXPnLCalculator構築用）
   *
   * @generated from field: repeated devtool.emodel.v1.PositionEntry jepx_positions = 2;
   */
  jepxPositions: PositionEntry[];

  /**
   * Floatingポジションデータ（燃調付き取引）
   *
   * @generated from field: repeated devtool.emodel.v1.FloatingPositionEntry floating_positions = 3;
   */
  floatingPositions: FloatingPositionEntry[];
};

/**
 * Describes the message devtool.emodel.v1.RiskCalcTradeData.
 * Use `create(RiskCalcTradeDataSchema)` to create a new message.
 */
export const RiskCalcTradeDataSchema: GenMessage<RiskCalcTradeData> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 1);

/**
 * プライシング設定
 *
 * @generated from message devtool.emodel.v1.RiskCalcPricingConfig
 */
export type RiskCalcPricingConfig = Message<"devtool.emodel.v1.RiskCalcPricingConfig"> & {
  /**
   * 月テナーテーブル
   *
   * @generated from field: devtool.emodel.v1.MonthTenorTable month_tenor_table = 1;
   */
  monthTenorTable?: MonthTenorTable;

  /**
   * 支払サイト（日数配列）
   *
   * @generated from field: repeated int32 payment_sites = 2;
   */
  paymentSites: number[];
};

/**
 * Describes the message devtool.emodel.v1.RiskCalcPricingConfig.
 * Use `create(RiskCalcPricingConfigSchema)` to create a new message.
 */
export const RiskCalcPricingConfigSchema: GenMessage<RiskCalcPricingConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 2);

/**
 * 集計設定
 *
 * @generated from message devtool.emodel.v1.RiskCalcAggregationConfig
 */
export type RiskCalcAggregationConfig = Message<"devtool.emodel.v1.RiskCalcAggregationConfig"> & {
  /**
   * 評価日数（0の場合は自動計算）
   *
   * @generated from field: int32 evaluation_days = 1;
   */
  evaluationDays: number;

  /**
   * 評価データ数（デフォルト: 733）
   *
   * @generated from field: int32 evaluation_data_count = 2;
   */
  evaluationDataCount: number;

  /**
   * オプション：担保計算設定（CollateralConfigはcommon_model.protoで定義）
   *
   * @generated from field: optional devtool.emodel.v1.CollateralConfig collateral = 3;
   */
  collateral?: CollateralConfig;

  /**
   * パーセンタイル選択（basis points単位。例: [9900, 9500, 9000, 8500, 8000, 7000, 6000, 5000]）
   * 省略時はデフォルト値を使用。1 bps = 0.0001（9900 bps = 99%）
   *
   * @generated from field: repeated int32 selected_percentiles_bps = 4;
   */
  selectedPercentilesBps: number[];
};

/**
 * Describes the message devtool.emodel.v1.RiskCalcAggregationConfig.
 * Use `create(RiskCalcAggregationConfigSchema)` to create a new message.
 */
export const RiskCalcAggregationConfigSchema: GenMessage<RiskCalcAggregationConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 3);

/**
 * 出力設定
 *
 * @generated from message devtool.emodel.v1.RiskCalcOutputConfig
 */
export type RiskCalcOutputConfig = Message<"devtool.emodel.v1.RiskCalcOutputConfig"> & {
  /**
   * オプション：VMSettle分布行列を生成するか
   *
   * @generated from field: bool generate_vm_settle_distribution_matrix = 1;
   */
  generateVmSettleDistributionMatrix: boolean;

  /**
   * 結果の詳細レベル
   *
   * @generated from field: devtool.emodel.v1.RiskCalcResultDetailLevel detail_level = 2;
   */
  detailLevel: RiskCalcResultDetailLevel;

  /**
   * SIMResult生成用設定（省略時はSIMResult生成をスキップ）
   *
   * @generated from field: optional devtool.emodel.v1.SIMResultConfig sim_result_config = 3;
   */
  simResultConfig?: SIMResultConfig;

  /**
   * オプション：exposure分解（witness）を計算して返すか。
   * 分位点計算の追加パス（ソート）を伴うため、デフォルトfalseで
   * 与信・EODなど非シミュレーター経路のコストをゼロにする。
   * dev-tool PFEシミュレーターのみtrueを設定する。
   *
   * @generated from field: bool include_exposure_decomposition = 4;
   */
  includeExposureDecomposition: boolean;

  /**
   * オプション：シナリオ一本線分解の対象シナリオ index（手動指定・診断用）。
   * include_exposure_decomposition とは独立。dev-tool PFEシミュレーター専用。
   *
   * @generated from field: repeated int32 decomposition_scenario_indices = 5;
   */
  decompositionScenarioIndices: number[];

  /**
   * オプション：シナリオ一本線分解の対象をセマンティックに選ぶ（index は
   * 外から意味が読めないため、通常はこちらを使う）。indices と併用可。
   * indices・selectors とも空なら一本線分解は計算しない。
   *
   * @generated from field: repeated devtool.emodel.v1.PFEScenarioSelector decomposition_scenario_selectors = 6;
   */
  decompositionScenarioSelectors: PFEScenarioSelector[];
};

/**
 * Describes the message devtool.emodel.v1.RiskCalcOutputConfig.
 * Use `create(RiskCalcOutputConfigSchema)` to create a new message.
 */
export const RiskCalcOutputConfigSchema: GenMessage<RiskCalcOutputConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 4);

/**
 * 日次電力コストエントリ（Go DailyPowerCosts の nil対応）
 *
 * @generated from message devtool.emodel.v1.DailyPowerCostEntry
 */
export type DailyPowerCostEntry = Message<"devtool.emodel.v1.DailyPowerCostEntry"> & {
  /**
   * 値が存在するか（falseの場合はnil相当）
   *
   * @generated from field: bool has_value = 1;
   */
  hasValue: boolean;

  /**
   * 値（has_value=trueの場合のみ有効）
   *
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message devtool.emodel.v1.DailyPowerCostEntry.
 * Use `create(DailyPowerCostEntrySchema)` to create a new message.
 */
export const DailyPowerCostEntrySchema: GenMessage<DailyPowerCostEntry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 5);

/**
 * ポジションエントリ（Go position.NetDealDeliveryTermWithMonthTenors 相当）
 *
 * @generated from message devtool.emodel.v1.PositionEntry
 */
export type PositionEntry = Message<"devtool.emodel.v1.PositionEntry"> & {
  /**
   * Symbol: "{AREA}_{HOURTYPE}" (例: "TOKYO_BASE", "KANSAI_PEAK")
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * 月テナー（1, 2, 3, ...）
   *
   * @generated from field: int32 month_tenor = 2;
   */
  monthTenor: number;

  /**
   * 正味ボリューム（kWh）- 正=買い、負=売り
   *
   * @generated from field: double net_volume_kwh = 3;
   */
  netVolumeKwh: number;
};

/**
 * Describes the message devtool.emodel.v1.PositionEntry.
 * Use `create(PositionEntrySchema)` to create a new message.
 */
export const PositionEntrySchema: GenMessage<PositionEntry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 6);

/**
 * Floatingポジションエントリ（燃調付き取引のポジション）
 *
 * @generated from message devtool.emodel.v1.FloatingPositionEntry
 */
export type FloatingPositionEntry = Message<"devtool.emodel.v1.FloatingPositionEntry"> & {
  /**
   * Floating Index Code（例: "JXXX_TBL_NEWC_v1", "JXXX_CBL_JKM_v1"）
   *
   * @generated from field: string floating_index_code = 1;
   */
  floatingIndexCode: string;

  /**
   * 月テナー（1, 2, 3, ...）
   *
   * @generated from field: int32 month_tenor = 2;
   */
  monthTenor: number;

  /**
   * 正味ボリューム（kWh）- 正=買い、負=売り
   *
   * @generated from field: double net_volume_kwh = 3;
   */
  netVolumeKwh: number;

  /**
   * 契約満期日
   *
   * @generated from field: google.type.Date contract_expiry = 4;
   */
  contractExpiry?: Date;

  /**
   * 約定固定価格
   *
   * @generated from field: double fixed_price = 5;
   */
  fixedPrice: number;

  /**
   * Pay/Receive方向
   *
   * @generated from field: devtool.emodel.v1.PayReceive pay_receive = 6;
   */
  payReceive: PayReceive;
};

/**
 * Describes the message devtool.emodel.v1.FloatingPositionEntry.
 * Use `create(FloatingPositionEntrySchema)` to create a new message.
 */
export const FloatingPositionEntrySchema: GenMessage<FloatingPositionEntry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 7);

/**
 * 月テナーテーブル（Go model.MonthTenorTable 相当）
 *
 * @generated from message devtool.emodel.v1.MonthTenorTable
 */
export type MonthTenorTable = Message<"devtool.emodel.v1.MonthTenorTable"> & {
  /**
   * day_tenor(1始まり) → month_tenor のマッピング配列
   * インデックス i に day_tenor = i+1 の月テナーが格納される
   *
   * @generated from field: repeated int32 day_to_month = 1;
   */
  dayToMonth: number[];
};

/**
 * Describes the message devtool.emodel.v1.MonthTenorTable.
 * Use `create(MonthTenorTableSchema)` to create a new message.
 */
export const MonthTenorTableSchema: GenMessage<MonthTenorTable> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 8);

/**
 * SIMResult生成設定（Go CalculateByPortfolioInput の一部に相当）
 *
 * @generated from message devtool.emodel.v1.SIMResultConfig
 */
export type SIMResultConfig = Message<"devtool.emodel.v1.SIMResultConfig"> & {
  /**
   * ケースID
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * ポートフォリオID
   *
   * @generated from field: string portfolio_id = 2;
   */
  portfolioId: string;

  /**
   * 組織ID配列
   *
   * @generated from field: repeated string organization_ids = 3;
   */
  organizationIds: string[];

  /**
   * 組織名配列
   *
   * @generated from field: repeated string organization_names = 4;
   */
  organizationNames: string[];

  /**
   * クレジットリミット（LimitData.CreLimit相当）
   *
   * @generated from field: double credit_limit = 5;
   */
  creditLimit: number;

  /**
   * 流動性リミット（LimitData.LiqLimit相当）
   *
   * @generated from field: double liquidity_limit = 6;
   */
  liquidityLimit: number;

  /**
   * MTM合計（MTMSums.TotalMTMSum相当）
   *
   * @generated from field: double total_mtm_sum = 7;
   */
  totalMtmSum: number;

  /**
   * JEPX MTM合計（MTMSums.JEPXMtMSum相当）
   *
   * @generated from field: double jepx_mtm_sum = 8;
   */
  jepxMtmSum: number;

  /**
   * 総kWh（MTMSums.TotalKwh相当）
   *
   * @generated from field: double total_kwh = 9;
   */
  totalKwh: number;

  /**
   * 総BG kWh（MTMSums.TotalBgKwh相当）
   *
   * @generated from field: double total_bg_kwh = 10;
   */
  totalBgKwh: number;

  /**
   * kWhカウント（MTMSums.KwhCount相当）
   *
   * @generated from field: int32 kwh_count = 11;
   */
  kwhCount: number;

  /**
   * 最大月テナー
   *
   * @generated from field: int32 max_month_tenor = 12;
   */
  maxMonthTenor: number;

  /**
   * マージンコール初回支払日までの日数（0の場合は未設定）
   *
   * @generated from field: int32 first_margin_call_payment_days = 13;
   */
  firstMarginCallPaymentDays: number;
};

/**
 * Describes the message devtool.emodel.v1.SIMResultConfig.
 * Use `create(SIMResultConfigSchema)` to create a new message.
 */
export const SIMResultConfigSchema: GenMessage<SIMResultConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 9);

/**
 * SIMResult + Detail（Go pfetypes.SIMResultAndDetail 相当）
 *
 * @generated from message devtool.emodel.v1.SIMResultAndDetail
 */
export type SIMResultAndDetail = Message<"devtool.emodel.v1.SIMResultAndDetail"> & {
  /**
   * @generated from field: devtool.emodel.v1.SIMResult sim_result = 1;
   */
  simResult?: SIMResult;

  /**
   * @generated from field: optional devtool.emodel.v1.SIMResultDetail sim_result_detail = 2;
   */
  simResultDetail?: SIMResultDetail;
};

/**
 * Describes the message devtool.emodel.v1.SIMResultAndDetail.
 * Use `create(SIMResultAndDetailSchema)` to create a new message.
 */
export const SIMResultAndDetailSchema: GenMessage<SIMResultAndDetail> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 10);

/**
 * SIMResult（Go pfetypes.SIMResult 相当）
 *
 * @generated from message devtool.emodel.v1.SIMResult
 */
export type SIMResult = Message<"devtool.emodel.v1.SIMResult"> & {
  /**
   * ケースID
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * ポートフォリオID
   *
   * @generated from field: string portfolio_id = 2;
   */
  portfolioId: string;

  /**
   * パーセンタイル（basis points単位。例: 9900 = 99%, 9500 = 95%）
   *
   * @generated from field: int32 percentile_bps = 3;
   */
  percentileBps: number;

  /**
   * 結果タイプ
   *
   * @generated from field: devtool.emodel.v1.RiskCalcResultType result_type = 4;
   */
  resultType: RiskCalcResultType;

  /**
   * シミュレーションピーク値（全期間最大）
   *
   * @generated from field: double sim_peak = 5;
   */
  simPeak: number;

  /**
   * シミュレーションピーク値（1ヶ月以内最大）
   *
   * @generated from field: double sim_peak_1m = 6;
   */
  simPeak1m: number;

  /**
   * シミュレーションピーク値（2ヶ月以内最大）
   *
   * @generated from field: double sim_peak_2m = 7;
   */
  simPeak2m: number;

  /**
   * シミュレーションピーク値（マージンコールまで最大）
   *
   * @generated from field: double sim_peak_mc = 8;
   */
  simPeakMc: number;

  /**
   * サイズ（曲線下面積）
   *
   * @generated from field: double size = 9;
   */
  size: number;

  /**
   * マージンコール初回支払日までの日数
   *
   * @generated from field: int32 first_margin_call_payment_days = 10;
   */
  firstMarginCallPaymentDays: number;

  /**
   * シミュレーションピーク値（中間清算期間最大）
   *
   * @generated from field: double sim_peak_ckssp = 11;
   */
  simPeakCkssp: number;

  /**
   * この (percentile, result_type) の日次分位カーブ。index i = day tenor i+1
   * （基準日翌日起点、エクスポージャー行列の列と同じ並び）。
   * sim_peak_* はこのカーブの prefix max に過ぎないため、切り取り位置の判断を
   * クライアント側で行えるように生カーブを返す。
   *
   * @generated from field: repeated double daily_values = 12;
   */
  dailyValues: number[];
};

/**
 * Describes the message devtool.emodel.v1.SIMResult.
 * Use `create(SIMResultSchema)` to create a new message.
 */
export const SIMResultSchema: GenMessage<SIMResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 11);

/**
 * SIMResultDetail（Go pfetypes.SIMResultDetail 相当）
 *
 * @generated from message devtool.emodel.v1.SIMResultDetail
 */
export type SIMResultDetail = Message<"devtool.emodel.v1.SIMResultDetail"> & {
  /**
   * 組織ID配列
   *
   * @generated from field: repeated string organization_ids = 1;
   */
  organizationIds: string[];

  /**
   * 組織名配列
   *
   * @generated from field: repeated string organization_names = 2;
   */
  organizationNames: string[];

  /**
   * クレジットリミット
   *
   * @generated from field: double credit_limit = 3;
   */
  creditLimit: number;

  /**
   * 流動性リミット
   *
   * @generated from field: double liquidity_limit = 4;
   */
  liquidityLimit: number;

  /**
   * クレジットリミット内か
   *
   * @generated from field: bool is_within_credit_limit = 5;
   */
  isWithinCreditLimit: boolean;

  /**
   * 流動性リミット内か
   *
   * @generated from field: bool is_within_liquidity_limit = 6;
   */
  isWithinLiquidityLimit: boolean;

  /**
   * サイズ対採用比率
   *
   * @generated from field: double size_to_adopted_ratio = 7;
   */
  sizeToAdoptedRatio: number;

  /**
   * 平均電力
   *
   * @generated from field: double average_power = 8;
   */
  averagePower: number;

  /**
   * 総kWh
   *
   * @generated from field: double total_kwh = 9;
   */
  totalKwh: number;

  /**
   * 最大期間
   *
   * @generated from field: int32 max_term = 10;
   */
  maxTerm: number;

  /**
   * 採用評価数量
   *
   * @generated from field: double adopted_evaluation_quantity = 11;
   */
  adoptedEvaluationQuantity: number;

  /**
   * MTM合計
   *
   * @generated from field: double sum_mtm = 12;
   */
  sumMtm: number;

  /**
   * 最大積み上げ電力コスト
   *
   * @generated from field: double max_stacking_power_cost = 13;
   */
  maxStackingPowerCost: number;

  /**
   * 最大積み上げ電力コスト（1ヶ月）
   *
   * @generated from field: double max_stacking_power_cost_1m = 14;
   */
  maxStackingPowerCost1m: number;

  /**
   * 最大積み上げ電力コスト（10日）
   *
   * @generated from field: double max_stacking_power_cost_10d = 15;
   */
  maxStackingPowerCost10d: number;

  /**
   * 総電力コストkWh
   *
   * @generated from field: double total_power_cost_kwh = 16;
   */
  totalPowerCostKwh: number;

  /**
   * 総BG kWh
   *
   * @generated from field: double total_bg_kwh = 17;
   */
  totalBgKwh: number;
};

/**
 * Describes the message devtool.emodel.v1.SIMResultDetail.
 * Use `create(SIMResultDetailSchema)` to create a new message.
 */
export const SIMResultDetailSchema: GenMessage<SIMResultDetail> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 12);

/**
 * 密行列（Go gonum/mat.Dense 相当）
 *
 * @generated from message devtool.emodel.v1.DenseMatrix
 */
export type DenseMatrix = Message<"devtool.emodel.v1.DenseMatrix"> & {
  /**
   * 行数
   *
   * @generated from field: int32 rows = 1;
   */
  rows: number;

  /**
   * 列数
   *
   * @generated from field: int32 cols = 2;
   */
  cols: number;

  /**
   * データ（row-major order: data[i*cols + j] = matrix[i][j]）
   *
   * @generated from field: repeated double data = 3;
   */
  data: number[];
};

/**
 * Describes the message devtool.emodel.v1.DenseMatrix.
 * Use `create(DenseMatrixSchema)` to create a new message.
 */
export const DenseMatrixSchema: GenMessage<DenseMatrix> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 13);

/**
 * CalculatePFEResult相当（Go riskcalcengine.CalculatePFEResult）
 *
 * @generated from message devtool.emodel.v1.CalculatePFEMatrices
 */
export type CalculatePFEMatrices = Message<"devtool.emodel.v1.CalculatePFEMatrices"> & {
  /**
   * 日次PnL
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_pnl = 1;
   */
  dailyPnl?: DenseMatrix;

  /**
   * 日次PnL行列
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_pnl_matrix = 2;
   */
  dailyPnlMatrix?: DenseMatrix;

  /**
   * 日次累積和
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums = 3;
   */
  dailyCumulativeSums?: DenseMatrix;

  /**
   * 日次累積和 + JEPX PnL + MTM
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl_add_mtm = 4;
   */
  dailyCumulativeSumsWithJepxPnlAddMtm?: DenseMatrix;

  /**
   * 日次累積和 + JEPX PnL + MTM + 電力コスト
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl_add_mtm_power_costs = 5;
   */
  dailyCumulativeSumsWithJepxPnlAddMtmPowerCosts?: DenseMatrix;

  /**
   * 日次累積和 + JEPX PnL + MTM + 電力コスト（担保なし）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl_add_mtm_power_costs_no_collateral = 6;
   */
  dailyCumulativeSumsWithJepxPnlAddMtmPowerCostsNoCollateral?: DenseMatrix;

  /**
   * JEPX日次PnL
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl = 7;
   */
  jepxDailyPnl?: DenseMatrix;

  /**
   * JEPX日次PnL行列
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl_matrix = 8;
   */
  jepxDailyPnlMatrix?: DenseMatrix;

  /**
   * JEPX日次PnL行列（期間別）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl_matrix_by_term = 9;
   */
  jepxDailyPnlMatrixByTerm?: DenseMatrix;

  /**
   * 日次累積和 + JEPX PnL
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl = 10;
   */
  dailyCumulativeSumsWithJepxPnl?: DenseMatrix;

  /**
   * 担保日次累積和 + MTM + 電力コスト（担保計算有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_daily_cumulative_sums_add_mtm_power_costs = 11;
   */
  collateralDailyCumulativeSumsAddMtmPowerCosts?: DenseMatrix;

  /**
   * 担保日次PnL行列（担保計算有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_daily_pnl_matrix = 12;
   */
  collateralDailyPnlMatrix?: DenseMatrix;

  /**
   * VM計算（担保計算有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix vm_calc = 13;
   */
  vmCalc?: DenseMatrix;

  /**
   * VM決済（担保計算有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix vm_settle = 14;
   */
  vmSettle?: DenseMatrix;

  /**
   * 日次累積和（流動性）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix daily_cumulative_sums_liquidity = 15;
   */
  dailyCumulativeSumsLiquidity?: DenseMatrix;

  /**
   * Intermediate series of the deposit-integrated bilateral model
   * (CSA_TYPE_BILATERAL only), raw [scenario x day].
   *
   * @generated from field: optional devtool.emodel.v1.BilateralDepositMatrices bilateral_deposit = 25;
   */
  bilateralDeposit?: BilateralDepositMatrices;

  /**
   * Floating日次PnL
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl = 20;
   */
  floatingDailyPnl?: DenseMatrix;

  /**
   * Floating日次PnL行列
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl_matrix = 21;
   */
  floatingDailyPnlMatrix?: DenseMatrix;

  /**
   * Floating日次累積和
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_cumulative_sums = 22;
   */
  floatingDailyCumulativeSums?: DenseMatrix;

  /**
   * 電力+Floating合算日次累積和（Scenario単位で合算後）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_daily_cumulative_sums = 23;
   */
  combinedDailyCumulativeSums?: DenseMatrix;

  /**
   * 電力+Floating合算日次累積和 + MTM + 電力コスト
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_daily_cumulative_sums_add_mtm_power_costs = 24;
   */
  combinedDailyCumulativeSumsAddMtmPowerCosts?: DenseMatrix;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePFEMatrices.
 * Use `create(CalculatePFEMatricesSchema)` to create a new message.
 */
export const CalculatePFEMatricesSchema: GenMessage<CalculatePFEMatrices> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 14);

/**
 * DistributionMatrix相当（Go riskcalcengine.DistributionMatrix）
 * BilateralDepositMatrices exposes every intermediate series of the
 * deposit-integrated bilateral collateral model (相互差し入れ＋預託金統合,
 * CSA_TYPE_BILATERAL). Inside CalculatePFEMatrices the matrices are raw
 * [scenario x day]; inside DistributionMatrices / SelectedDistributionMatrices
 * they are quantile distributions [quantile x day], like the other series.
 *
 * @generated from message devtool.emodel.v1.BilateralDepositMatrices
 */
export type BilateralDepositMatrices = Message<"devtool.emodel.v1.BilateralDepositMatrices"> & {
  /**
   * 顧客必要証拠金Total = max(MTM, 0) + initial_margin.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix required_customer_margin = 1;
   */
  requiredCustomerMargin?: DenseMatrix;

  /**
   * eClear必要証拠金 = max(-MTM, 0).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix required_clearer_margin = 2;
   */
  requiredClearerMargin?: DenseMatrix;

  /**
   * eClear保有の顧客預託金＋保証残高 (EOD).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_held_deposit = 3;
   */
  clearerHeldDeposit?: DenseMatrix;

  /**
   * 顧客保有のeClear預託金残高 (EOD).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_held_deposit = 4;
   */
  customerHeldDeposit?: DenseMatrix;

  /**
   * 顧客側不足額 (signed; negative = refund back to the customer).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_shortfall = 5;
   */
  customerShortfall?: DenseMatrix;

  /**
   * eClear側不足額 (floored at 0).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_shortfall = 6;
   */
  clearerShortfall?: DenseMatrix;

  /**
   * 顧客マージンコール (MTA・コール日ゲート後、翌日決済).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_margin_call = 7;
   */
  customerMarginCall?: DenseMatrix;

  /**
   * eClearマージンコール.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_margin_call = 8;
   */
  clearerMarginCall?: DenseMatrix;

  /**
   * 顧客によるeClear側余剰の引出 (コール日翌日、非正値).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_withdrawal = 9;
   */
  customerWithdrawal?: DenseMatrix;

  /**
   * 使用可能額・顧客側 = clearer_held_deposit - required_customer_margin.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_available = 10;
   */
  customerAvailable?: DenseMatrix;

  /**
   * 使用可能額・eClear側 = customer_held_deposit - required_clearer_margin.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_available = 11;
   */
  clearerAvailable?: DenseMatrix;

  /**
   * ── クオンツ統一証拠金エンジンの定義そのままの合成系列。UI 側で行列の
   * 差分から擬似的に組み立てず、エンジンが直接計算して返す。 ──
   * 顧客側ネット(T) = 顧客必要証拠金(T) − 顧客預託金(T).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_net = 12;
   */
  customerNet?: DenseMatrix;

  /**
   * eClear側ネット(T) = eClear必要証拠金(T) − eClear預託金(T).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_net = 13;
   */
  clearerNet?: DenseMatrix;

  /**
   * 両建てネット(T) = 顧客側ネット(T) − eClear側ネット(T).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix net_position = 14;
   */
  netPosition?: DenseMatrix;

  /**
   * net_exposure(T) = max(両建てネット(T), 0).
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix net_exposure = 15;
   */
  netExposure?: DenseMatrix;

  /**
   * 顧客預託金の日次キャッシュフロー（着地ベース: 請求の着金 + 返却。
   * clearer_held_deposit の日次差分に一致する）.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix customer_deposit_flow = 16;
   */
  customerDepositFlow?: DenseMatrix;

  /**
   * eClear預託金の日次キャッシュフロー（着地ベース）.
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix clearer_deposit_flow = 17;
   */
  clearerDepositFlow?: DenseMatrix;
};

/**
 * Describes the message devtool.emodel.v1.BilateralDepositMatrices.
 * Use `create(BilateralDepositMatricesSchema)` to create a new message.
 */
export const BilateralDepositMatricesSchema: GenMessage<BilateralDepositMatrices> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 15);

/**
 * @generated from message devtool.emodel.v1.DistributionMatrices
 */
export type DistributionMatrices = Message<"devtool.emodel.v1.DistributionMatrices"> & {
  /**
   * MTMなし分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix no_mtm = 1;
   */
  noMtm?: DenseMatrix;

  /**
   * MTMあり分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm = 2;
   */
  addMtm?: DenseMatrix;

  /**
   * MTM + 電力コスト分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm_power_costs = 3;
   */
  addMtmPowerCosts?: DenseMatrix;

  /**
   * JEPX分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx = 4;
   */
  jepx?: DenseMatrix;

  /**
   * MTM + JEPX分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm_jepx = 5;
   */
  addMtmJepx?: DenseMatrix;

  /**
   * 流動性PFE分布（オプション）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix liquidity_pfe = 6;
   */
  liquidityPfe?: DenseMatrix;

  /**
   * VM決済分布（generate_vm_settle_distribution_matrix=true時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix vm_settle = 7;
   */
  vmSettle?: DenseMatrix;

  /**
   * Floating PFE分布（燃調のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_pfe = 10;
   */
  floatingPfe?: DenseMatrix;

  /**
   * 電力+Floating合算PFE分布
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_pfe = 11;
   */
  combinedPfe?: DenseMatrix;

  /**
   * 電力+Floating合算 + MTM + 電力コスト分布
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_add_mtm_power_costs = 12;
   */
  combinedAddMtmPowerCosts?: DenseMatrix;

  /**
   * Quantile distributions of the deposit-integrated bilateral series
   * (CSA_TYPE_BILATERAL only).
   *
   * @generated from field: optional devtool.emodel.v1.BilateralDepositMatrices bilateral_deposit = 13;
   */
  bilateralDeposit?: BilateralDepositMatrices;
};

/**
 * Describes the message devtool.emodel.v1.DistributionMatrices.
 * Use `create(DistributionMatricesSchema)` to create a new message.
 */
export const DistributionMatricesSchema: GenMessage<DistributionMatrices> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 16);

/**
 * PFEExposureDecomposition はエクスポージャを検証可能な成分に分解して返す。
 * 各項目を足し戻すと元の PFE(add_mtm_with_power_cost)になる:
 *   無担保[q][d] = base_pnl[q][d] + mtm[d] + power_costs[d] + jepx_difference[d] - cash_io[d]
 *   担保後[q][d] = 無担保[q][d] - collateral_reduction[q][d]
 * base_pnl は確率的成分(forward + JEPX PnL)なので分位点分布で1本、
 * mtm/power_costs/jepx_difference/cash_io は全シナリオ一律の確定日次額。
 *
 * @generated from message devtool.emodel.v1.PFEExposureDecomposition
 */
export type PFEExposureDecomposition = Message<"devtool.emodel.v1.PFEExposureDecomposition"> & {
  /**
   * forward + JEPX PnL の分位点分布（確率ベース, 分位点 x 日）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix base_pnl = 1;
   */
  basePnl?: DenseMatrix;

  /**
   * MTM 日次（確定, 全分位点に一律加算）
   *
   * @generated from field: repeated double mtm = 2;
   */
  mtm: number[];

  /**
   * BG 品代 日次（固定+変動, 確定）
   *
   * @generated from field: repeated double power_costs = 3;
   */
  powerCosts: number[];

  /**
   * JEPX 差額コスト 日次（確定）
   *
   * @generated from field: repeated double jepx_difference = 4;
   */
  jepxDifference: number[];

  /**
   * 入出金 日次（確定, エクスポージャから減算）
   *
   * @generated from field: repeated double cash_io = 5;
   */
  cashIo: number[];

  /**
   * 担保による削減（分位点 x 日, 担保計算有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_reduction = 6;
   */
  collateralReduction?: DenseMatrix;

  /**
   * 相互差し入れ(CSA_TYPE_BILATERAL)時のみ: collateral_reduction の内訳。
   * 中間系列「無担保 − eClear保有残高」を分位化して差分を取っているため、
   *   collateral_reduction = collateral_clearer_held - collateral_customer_held
   * が分位後も厳密に成り立つ。
   * eClear保有 顧客預託金残高によるエクスポージャ削減分（分位点 x 日）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_clearer_held = 7;
   */
  collateralClearerHeld?: DenseMatrix;

  /**
   * 顧客保有 eClear預託金残高によるエクスポージャ戻し分（分位点 x 日）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_customer_held = 8;
   */
  collateralCustomerHeld?: DenseMatrix;
};

/**
 * Describes the message devtool.emodel.v1.PFEExposureDecomposition.
 * Use `create(PFEExposureDecompositionSchema)` to create a new message.
 */
export const PFEExposureDecompositionSchema: GenMessage<PFEExposureDecomposition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 17);

/**
 * SelectedPnlDistributionMatrix相当（Go riskcalcengine.SelectedPnlDistributionMatrix）
 *
 * @generated from message devtool.emodel.v1.SelectedDistributionMatrices
 */
export type SelectedDistributionMatrices = Message<"devtool.emodel.v1.SelectedDistributionMatrices"> & {
  /**
   * MTMなし選択分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix no_mtm = 1;
   */
  noMtm?: DenseMatrix;

  /**
   * MTMあり選択分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm = 2;
   */
  addMtm?: DenseMatrix;

  /**
   * MTM + 電力コスト選択分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm_with_power_cost = 3;
   */
  addMtmWithPowerCost?: DenseMatrix;

  /**
   * JEPX選択分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx = 4;
   */
  jepx?: DenseMatrix;

  /**
   * MTM + JEPX選択分布
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix add_mtm_jepx = 5;
   */
  addMtmJepx?: DenseMatrix;

  /**
   * 流動性PFE選択分布（オプション）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix liquidity_pfe = 6;
   */
  liquidityPfe?: DenseMatrix;

  /**
   * VM決済選択分布（generate_vm_settle_distribution_matrix=true時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix vm_settle = 7;
   */
  vmSettle?: DenseMatrix;

  /**
   * Floating PFE選択分布（燃調のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_pfe = 10;
   */
  floatingPfe?: DenseMatrix;

  /**
   * 電力+Floating合算PFE選択分布
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_pfe = 11;
   */
  combinedPfe?: DenseMatrix;

  /**
   * 電力+Floating合算 + MTM + 電力コスト選択分布
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_add_mtm_power_costs = 12;
   */
  combinedAddMtmPowerCosts?: DenseMatrix;

  /**
   * Deprecated: 包絡分解（独立分位化系列の差）。担保レイヤーがどのシナリオの
   * 実額でもなく検証に使えないため、埋めるのをやめた。フィールドは互換のため残す。
   *
   * @generated from field: optional devtool.emodel.v1.PFEExposureDecomposition pfe_exposure_decomposition = 13 [deprecated = true];
   * @deprecated
   */
  pfeExposureDecomposition?: PFEExposureDecomposition;

  /**
   * Quantile distributions of the deposit-integrated bilateral series
   * (CSA_TYPE_BILATERAL only).
   *
   * @generated from field: optional devtool.emodel.v1.BilateralDepositMatrices bilateral_deposit = 14;
   */
  bilateralDeposit?: BilateralDepositMatrices;

  /**
   * witness 分解 = 最終系列の nearest-rank を叩いた実在シナリオの実額による分解。
   *
   * @generated from field: optional devtool.emodel.v1.PFEExposureDecomposition pfe_exposure_decomposition_witness = 15;
   */
  pfeExposureDecompositionWitness?: PFEExposureDecomposition;

  /**
   * 診断用。witness シナリオの行 index(percentile×日、値は整数)。
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix witness_scenario_indices = 16;
   */
  witnessScenarioIndices?: DenseMatrix;

  /**
   * シナリオ一本線分解 = 指定シナリオの実額パス（ソートなし）。
   * output_config.decomposition_scenario_indices が非空のときのみ設定。
   *
   * @generated from field: optional devtool.emodel.v1.PFEScenarioDecomposition pfe_scenario_decomposition = 17;
   */
  pfeScenarioDecomposition?: PFEScenarioDecomposition;

  /**
   * 担保計算が有効なときのマージンコールスケジュール（チャート注記用）。
   * DETAILED 以上でのみ設定。
   *
   * @generated from field: optional devtool.emodel.v1.MarginCallScheduleInfo margin_call_schedule = 18;
   */
  marginCallSchedule?: MarginCallScheduleInfo;
};

/**
 * Describes the message devtool.emodel.v1.SelectedDistributionMatrices.
 * Use `create(SelectedDistributionMatricesSchema)` to create a new message.
 */
export const SelectedDistributionMatricesSchema: GenMessage<SelectedDistributionMatrices> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 18);

/**
 * MarginCallScheduleInfo は担保計算に実際に使われたマージンコール
 * スケジュールをチャート注記向けに返す。日はすべて評価行列の列に対応する
 * 1-based の日テナー（d1 = 基準日翌日）。
 *
 * @generated from message devtool.emodel.v1.MarginCallScheduleInfo
 */
export type MarginCallScheduleInfo = Message<"devtool.emodel.v1.MarginCallScheduleInfo"> & {
  /**
   * マージンコール判定日
   *
   * @generated from field: repeated int32 margin_call_day_tenors = 1;
   */
  marginCallDayTenors: number[];

  /**
   * 各判定日のコール着金日（margin_call_day_tenors と同順。評価期間外は -1）
   *
   * @generated from field: repeated int32 payment_due_day_tenors = 2;
   */
  paymentDueDayTenors: number[];
};

/**
 * Describes the message devtool.emodel.v1.MarginCallScheduleInfo.
 * Use `create(MarginCallScheduleInfoSchema)` to create a new message.
 */
export const MarginCallScheduleInfoSchema: GenMessage<MarginCallScheduleInfo> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 19);

/**
 * シナリオ一本線分解。指定シナリオ s の各成分の実額パスを並び替えなしで返す。
 * レイヤー合計はシナリオ単位の恒等式なので厳密に adjusted と一致する：
 *   base_pnl[s][d] + mtm[d] + power_costs[d] + jepx_difference[d] − cash_io[d]
 *     − collateral_reduction[s][d] = adjusted[s][d]
 *   (bilateral 時は collateral_reduction = clearer_held − customer_held)
 * percentile ソート前の検証（担保残高の階段状パス等）に使う。
 *
 * @generated from message devtool.emodel.v1.PFEScenarioDecomposition
 */
export type PFEScenarioDecomposition = Message<"devtool.emodel.v1.PFEScenarioDecomposition"> & {
  /**
   * 下記行列の行に対応するシナリオ index（要求のうち範囲外を skip した後）
   *
   * @generated from field: repeated int32 scenario_indices = 1;
   */
  scenarioIndices: number[];

  /**
   * 累積ΔPnL+JEPX（シナリオ × 日）。floating ありは Combined+JEPX
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix base_pnl = 2;
   */
  basePnl?: DenseMatrix;

  /**
   * MTM 日次（確定, 全シナリオ共通）
   *
   * @generated from field: repeated double mtm = 3;
   */
  mtm: number[];

  /**
   * BG 品代 日次（固定+変動, 確定）
   *
   * @generated from field: repeated double power_costs = 4;
   */
  powerCosts: number[];

  /**
   * JEPX 差額コスト 日次（確定）
   *
   * @generated from field: repeated double jepx_difference = 5;
   */
  jepxDifference: number[];

  /**
   * 入出金 日次（確定, エクスポージャから減算）
   *
   * @generated from field: repeated double cash_io = 6;
   */
  cashIo: number[];

  /**
   * 担保による削減 = 無担保(s,d) − 勘案後(s,d)（シナリオ × 日, 担保有効時のみ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_reduction = 7;
   */
  collateralReduction?: DenseMatrix;

  /**
   * bilateral のみ: eClear保有 顧客預託金の実残高パス（シナリオ × 日, 階段状）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_clearer_held = 8;
   */
  collateralClearerHeld?: DenseMatrix;

  /**
   * bilateral のみ: 顧客保有 eClear預託金の実残高パス（シナリオ × 日, 階段状）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix collateral_customer_held = 9;
   */
  collateralCustomerHeld?: DenseMatrix;

  /**
   * 勘案後の最終一本線（シナリオ × 日）。積み上げ合計との一致検証用
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix adjusted = 10;
   */
  adjusted?: DenseMatrix;

  /**
   * 各行がどう選ばれたか（scenario_indices と同順・同数）。
   * 手動 index とセレクタ解決が同じシナリオに重なった場合は 1 行に dedupe し、
   * 最初に解決された基準のラベルを持つ。
   *
   * @generated from field: repeated devtool.emodel.v1.PFEScenarioTraceInfo trace_infos = 11;
   */
  traceInfos: PFEScenarioTraceInfo[];
};

/**
 * Describes the message devtool.emodel.v1.PFEScenarioDecomposition.
 * Use `create(PFEScenarioDecompositionSchema)` to create a new message.
 */
export const PFEScenarioDecompositionSchema: GenMessage<PFEScenarioDecomposition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 20);

/**
 * シナリオ一本線分解の 1 行がどう選ばれたかのラベル。
 *
 * @generated from message devtool.emodel.v1.PFEScenarioTraceInfo
 */
export type PFEScenarioTraceInfo = Message<"devtool.emodel.v1.PFEScenarioTraceInfo"> & {
  /**
   * シナリオ index（対応する行列の行）
   *
   * @generated from field: int32 scenario_index = 1;
   */
  scenarioIndex: number;

  /**
   * 選択基準（UNSPECIFIED = 手動 index 指定）
   *
   * @generated from field: devtool.emodel.v1.PFEScenarioSelector selector = 2;
   */
  selector: PFEScenarioSelector;

  /**
   * PEAK_WITNESS のみ: 対象 percentile（bps）
   *
   * @generated from field: optional int32 percentile_bps = 3;
   */
  percentileBps?: number;

  /**
   * PEAK 系のみ: ピークが立った日（0-based 評価日）
   *
   * @generated from field: optional int32 peak_day = 4;
   */
  peakDay?: number;
};

/**
 * Describes the message devtool.emodel.v1.PFEScenarioTraceInfo.
 * Use `create(PFEScenarioTraceInfoSchema)` to create a new message.
 */
export const PFEScenarioTraceInfoSchema: GenMessage<PFEScenarioTraceInfo> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 21);

/**
 * PortfolioAnalysisResult（Go riskcalcengine.PortfolioAnalysisResult 相当）
 *
 * @generated from message devtool.emodel.v1.PortfolioAnalysisResult
 */
export type PortfolioAnalysisResult = Message<"devtool.emodel.v1.PortfolioAnalysisResult"> & {
  /**
   * ケースID
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * 組織ID配列
   *
   * @generated from field: repeated string organization_ids = 2;
   */
  organizationIds: string[];

  /**
   * 組織名配列
   *
   * @generated from field: repeated string organization_names = 3;
   */
  organizationNames: string[];

  /**
   * タイプ（例: "Credit", "Liquidity", "Pricing_Liquidity"）
   *
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * 目的（例: "Credit Limit", "Future Limit"）
   *
   * @generated from field: string for_purpose = 5;
   */
  forPurpose: string;

  /**
   * 商品範囲（例: "All w/o special trade"）
   *
   * @generated from field: string product_scope = 6;
   */
  productScope: string;

  /**
   * ポートフォリオ（例: "個社", "eClear全取引"）
   *
   * @generated from field: string portfolio = 7;
   */
  portfolio: string;

  /**
   * 測定値（例: "PFE95per+BG品代受"）
   *
   * @generated from field: string measurement = 8;
   */
  measurement: string;

  /**
   * 期間（例: "MAX", "Max in 2Month"）
   *
   * @generated from field: string term = 9;
   */
  term: string;

  /**
   * 値
   *
   * @generated from field: double value = 10;
   */
  value: number;
};

/**
 * Describes the message devtool.emodel.v1.PortfolioAnalysisResult.
 * Use `create(PortfolioAnalysisResultSchema)` to create a new message.
 */
export const PortfolioAnalysisResultSchema: GenMessage<PortfolioAnalysisResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 22);

/**
 * NPVCubeResult stores Full Revaluation results as a flat array.
 * Dimensions: trades x dates x samples x depth (row-major order).
 *
 * Index layout:
 *   index = trade * (numDates * numSamples * depth)
 *         + date  * (numSamples * depth)
 *         + sample * depth
 *         + d
 *
 * @generated from message devtool.emodel.v1.NPVCubeResult
 */
export type NPVCubeResult = Message<"devtool.emodel.v1.NPVCubeResult"> & {
  /**
   * T0 基準日
   *
   * @generated from field: google.type.Date as_of = 1;
   */
  asOf?: Date;

  /**
   * 取引ID一覧
   *
   * @generated from field: repeated string trade_ids = 2;
   */
  tradeIds: string[];

  /**
   * 評価日一覧
   *
   * @generated from field: repeated google.type.Date dates = 3;
   */
  dates: Date[];

  /**
   * シナリオ数
   *
   * @generated from field: int32 num_samples = 4;
   */
  numSamples: number;

  /**
   * 値の種類数（通常 1 = NPV のみ）
   *
   * @generated from field: int32 depth = 5;
   */
  depth: number;

  /**
   * T0 時点の評価値: flat [numTrades * depth]
   *
   * @generated from field: repeated double t0_data = 6;
   */
  t0Data: number[];

  /**
   * 本体: flat [numTrades * numDates * numSamples * depth]
   *
   * @generated from field: repeated double data = 7;
   */
  data: number[];
};

/**
 * Describes the message devtool.emodel.v1.NPVCubeResult.
 * Use `create(NPVCubeResultSchema)` to create a new message.
 */
export const NPVCubeResultSchema: GenMessage<NPVCubeResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 23);

/**
 * Step 1 出力 / Step 2 入力: PnL計算結果
 *
 * @generated from message devtool.emodel.v1.PnLStepResult
 */
export type PnLStepResult = Message<"devtool.emodel.v1.PnLStepResult"> & {
  /**
   * Main PnL
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_pnl_matrix = 1;
   */
  dailyPnlMatrix?: DenseMatrix;

  /**
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums = 2;
   */
  dailyCumulativeSums?: DenseMatrix;

  /**
   * JEPX PnL（Step1で計算済み、Step2でterm変換する）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl_matrix = 3;
   */
  jepxDailyPnlMatrix?: DenseMatrix;

  /**
   * Floating PFE（存在する場合）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl = 10;
   */
  floatingDailyPnl?: DenseMatrix;

  /**
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl_matrix = 11;
   */
  floatingDailyPnlMatrix?: DenseMatrix;

  /**
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_cumulative_sums = 12;
   */
  floatingDailyCumulativeSums?: DenseMatrix;

  /**
   * Deprecated: CalculatePnL v2 では常に空。当日MTMは caller 側で
   * (カーブ価格 − 約定価格) × 数量 として計算する。
   *
   * @generated from field: repeated double floating_current_mtm = 13 [deprecated = true];
   * @deprecated
   */
  floatingCurrentMtm: number[];

  /**
   * Deprecated: CalculatePnL v2 では常に 0。
   *
   * @generated from field: double floating_total_current_mtm = 14 [deprecated = true];
   * @deprecated
   */
  floatingTotalCurrentMtm: number;

  /**
   * パラメータ引き継ぎ
   *
   * @generated from field: int32 num_dates = 20;
   */
  numDates: number;

  /**
   * @generated from field: int32 num_samples = 21;
   */
  numSamples: number;
};

/**
 * Describes the message devtool.emodel.v1.PnLStepResult.
 * Use `create(PnLStepResultSchema)` to create a new message.
 */
export const PnLStepResultSchema: GenMessage<PnLStepResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 24);

/**
 * Step 2 出力 / Step 3 入力: JEPX調整結果
 *
 * @generated from message devtool.emodel.v1.JepxAdjustmentResult
 */
export type JepxAdjustmentResult = Message<"devtool.emodel.v1.JepxAdjustmentResult"> & {
  /**
   * Main PnL（引き継ぎ）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_pnl_matrix = 1;
   */
  dailyPnlMatrix?: DenseMatrix;

  /**
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums = 2;
   */
  dailyCumulativeSums?: DenseMatrix;

  /**
   * JEPX加算済み累積和
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl = 3;
   */
  dailyCumulativeSumsWithJepxPnl?: DenseMatrix;

  /**
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_cumulative_sums_with_jepx_pnl_add_mtm = 4;
   */
  dailyCumulativeSumsWithJepxPnlAddMtm?: DenseMatrix;

  /**
   * JEPX行列
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl_matrix = 5;
   */
  jepxDailyPnlMatrix?: DenseMatrix;

  /**
   * @generated from field: devtool.emodel.v1.DenseMatrix jepx_daily_pnl_matrix_by_term = 6;
   */
  jepxDailyPnlMatrixByTerm?: DenseMatrix;

  /**
   * Floating（引き継ぎ）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl = 10;
   */
  floatingDailyPnl?: DenseMatrix;

  /**
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_pnl_matrix = 11;
   */
  floatingDailyPnlMatrix?: DenseMatrix;

  /**
   * @generated from field: optional devtool.emodel.v1.DenseMatrix floating_daily_cumulative_sums = 12;
   */
  floatingDailyCumulativeSums?: DenseMatrix;

  /**
   * Deprecated: CalculatePnL v2 経由では Step1 が空を渡すため常に空（引き継ぎのみ）。
   *
   * @generated from field: repeated double floating_current_mtm = 13 [deprecated = true];
   * @deprecated
   */
  floatingCurrentMtm: number[];

  /**
   * Deprecated: CalculatePnL v2 経由では常に 0。
   *
   * @generated from field: double floating_total_current_mtm = 14 [deprecated = true];
   * @deprecated
   */
  floatingTotalCurrentMtm: number;

  /**
   * Combined（floating存在時）
   *
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_daily_cumulative_sums = 20;
   */
  combinedDailyCumulativeSums?: DenseMatrix;

  /**
   * @generated from field: optional devtool.emodel.v1.DenseMatrix combined_daily_cumulative_sums_add_mtm_power_costs = 21;
   */
  combinedDailyCumulativeSumsAddMtmPowerCosts?: DenseMatrix;

  /**
   * パラメータ
   *
   * @generated from field: int32 num_dates = 30;
   */
  numDates: number;

  /**
   * @generated from field: int32 num_samples = 31;
   */
  numSamples: number;
};

/**
 * Describes the message devtool.emodel.v1.JepxAdjustmentResult.
 * Use `create(JepxAdjustmentResultSchema)` to create a new message.
 */
export const JepxAdjustmentResultSchema: GenMessage<JepxAdjustmentResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 25);

/**
 * Step 1: PnL計算リクエスト（v3: ポジション統一IF）
 * テナー座標は base_date からサーバー内で合成する（当月=0、境界=翌月1日）。
 * v2 の main_positions/jepx_positions/floating_positions は positions に統一された
 * （PnL計算では ticker/symbol による商品抽象化で十分で、JEPX期別変換・floating MTM等の
 * 内部差はPnL計算に無関係なため）。
 *
 * @generated from message devtool.emodel.v1.CalculatePnLRequest
 */
export type CalculatePnLRequest = Message<"devtool.emodel.v1.CalculatePnLRequest"> & {
  /**
   * 基準日
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * 評価日数（省略時: 365、上限: 3650）
   *
   * @generated from field: optional int32 evaluation_days = 8;
   */
  evaluationDays?: number;

  /**
   * 使用シナリオ数上限（省略時: 733）。整列後の日付軸の行数に対する上限として働き、
   * 直近N行（末尾）が採用される。上限: 10000
   *
   * @generated from field: optional int32 evaluation_data_count = 9;
   */
  evaluationDataCount?: number;

  /**
   * ポジション（1件以上必須）。旧 main/jepx/floating positions の統一表現。
   *
   * @generated from field: repeated devtool.emodel.v1.PnLPosition positions = 10;
   */
  positions: PnLPosition[];

  /**
   * true の場合 results（ポジション別行列）を計算せず空で返す。
   * レスポンスサイズを抑えたい場合に使う（cube 自体は展開後エントリ数
   * ×サンプル数×評価日数のサイズガードで制限されるため、大きすぎるリクエストは
   * このフラグの値に関わらず拒否される）。省略時（false）は results を計算する。
   *
   * @generated from field: bool exclude_position_results = 11;
   */
  excludePositionResults: boolean;

  /**
   * true の場合、使用した (symbol × 参照限月) ごとの系列詳細
   * （基準日カーブ価格 + 数量1単位あたりの日次PnL系列）を series_details として返す。
   * caller 側で収益率・対数収益率を復元して途中計算を検証する用途を想定。
   * 省略時（false）は返さない。
   *
   * @generated from field: bool include_series_details = 12;
   */
  includeSeriesDetails: boolean;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePnLRequest.
 * Use `create(CalculatePnLRequestSchema)` to create a new message.
 */
export const CalculatePnLRequestSchema: GenMessage<CalculatePnLRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 26);

/**
 * PnL計算対象のポジション（symbol × 参照限月期間で表現される統一ポジション）
 *
 * @generated from message devtool.emodel.v1.PnLPosition
 */
export type PnLPosition = Message<"devtool.emodel.v1.PnLPosition"> & {
  /**
   * 呼び出し元が付与する任意のID。空・重複可。results にそのままエコーされる
   * （検証はしない）。
   *
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * 系列識別子。データ層の ticker と同値（例: "LOGRET_POWER_TOKYO_BASE_JPY_PER_KWH"）。
   * 名前末尾の JPY_PER_<UNIT> が系列値の価格単位で、volume_per_month はその <UNIT> 建てで渡す。
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * 参照限月の期間（月精度・両端含む）。単一限月は from_month = to_month。
   * ラグ付き契約（n-2月参照等）は受渡月ではなく参照（fixing）限月を指定する。
   *
   * @generated from field: google.type.Date from_month = 3;
   */
  fromMonth?: Date;

  /**
   * @generated from field: google.type.Date to_month = 4;
   */
  toMonth?: Date;

  /**
   * 月あたりの符号付き数量（正=買い=価格上昇で利益）。契約式の係数はここに畳む。
   *
   * @generated from field: double volume_per_month = 5;
   */
  volumePerMonth: number;
};

/**
 * Describes the message devtool.emodel.v1.PnLPosition.
 * Use `create(PnLPositionSchema)` to create a new message.
 */
export const PnLPositionSchema: GenMessage<PnLPosition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 27);

/**
 * Step 1: PnL計算レスポンス（v3: ポジション別行列 + 整列済みsample_dates）
 *
 * @generated from message devtool.emodel.v1.CalculatePnLResponse
 */
export type CalculatePnLResponse = Message<"devtool.emodel.v1.CalculatePnLResponse"> & {
  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * @generated from field: int32 runtime_ms = 3;
   */
  runtimeMs: number;

  /**
   * 行の観測日（昇順。使用した全キーの日付集合の共通部分に整列済み。
   * evaluation_data_count の上限を適用した後の直近N件）。
   *
   * @generated from field: repeated google.type.Date sample_dates = 4;
   */
  sampleDates: Date[];

  /**
   * サンプル行数（= len(sample_dates)）。日付整列後の「共通営業日数（直近N）」。
   *
   * @generated from field: int32 num_samples = 5;
   */
  numSamples: number;

  /**
   * 評価日数（= 列数）
   *
   * @generated from field: int32 num_dates = 6;
   */
  numDates: number;

  /**
   * 全ポジション合算の日次PnL（サンプル × 日）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix total_daily_pnl_matrix = 7;
   */
  totalDailyPnlMatrix?: DenseMatrix;

  /**
   * 全ポジション合算の日次累積和（サンプル × 日）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix total_daily_cumulative_sums = 8;
   */
  totalDailyCumulativeSums?: DenseMatrix;

  /**
   * ポジション別結果。positions と同順・同数（exclude_position_results=true 時は空）。
   *
   * @generated from field: repeated devtool.emodel.v1.PositionPnLResult results = 9;
   */
  results: PositionPnLResult[];

  /**
   * 使用した (symbol × 参照限月) ごとの系列詳細
   * （include_series_details=true 時のみ。順序は保証しない）。
   *
   * @generated from field: repeated devtool.emodel.v1.SymbolMonthSeriesDetail series_details = 10;
   */
  seriesDetails: SymbolMonthSeriesDetail[];
};

/**
 * Describes the message devtool.emodel.v1.CalculatePnLResponse.
 * Use `create(CalculatePnLResponseSchema)` to create a new message.
 */
export const CalculatePnLResponseSchema: GenMessage<CalculatePnLResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 28);

/**
 * ポジション別のPnL結果。cumulative は caller 側で
 * cum[s][d] = Σ_{i=s..min(s+d,N-1)} daily[i][d] として導出する。
 *
 * @generated from message devtool.emodel.v1.PositionPnLResult
 */
export type PositionPnLResult = Message<"devtool.emodel.v1.PositionPnLResult"> & {
  /**
   * request の PnLPosition.position_id のエコー
   *
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * ポジション別の日次PnL（サンプル × 日）
   *
   * @generated from field: devtool.emodel.v1.DenseMatrix daily_pnl_matrix = 2;
   */
  dailyPnlMatrix?: DenseMatrix;
};

/**
 * Describes the message devtool.emodel.v1.PositionPnLResult.
 * Use `create(PositionPnLResultSchema)` to create a new message.
 */
export const PositionPnLResultSchema: GenMessage<PositionPnLResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 29);

/**
 * 使用した (symbol × 参照限月) ごとの系列詳細（検証用の途中出力）。
 * 評価手法には依存しない: daily_pnl_per_unit は PnL 計算にそのまま使われる
 * 系列値で、ポジションの日次PnL = Σ_限月 volume_per_month × daily_pnl_per_unit[i]。
 * 収益率が必要な場合は caller 側で
 *   単純収益率   = daily_pnl_per_unit[i] / base_curve_price
 *   対数収益率   = LN(1 + daily_pnl_per_unit[i] / base_curve_price)
 * と復元する（対数収益率ベースの LOGRET_* 系列では系列値 = C × (EXP(r) − 1) のため厳密に一致）。
 *
 * @generated from message devtool.emodel.v1.SymbolMonthSeriesDetail
 */
export type SymbolMonthSeriesDetail = Message<"devtool.emodel.v1.SymbolMonthSeriesDetail"> & {
  /**
   * 系列識別子（PnLPosition.symbol と同じ語彙）
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * 参照限月（月精度）
   *
   * @generated from field: google.type.Date month = 2;
   */
  month?: Date;

  /**
   * 基準日からのテナー（照合用の冗長情報）
   *
   * @generated from field: int32 month_tenor = 3;
   */
  monthTenor: number;

  /**
   * 基準日カーブ価格 C。単位は symbol 名の JPY_PER_<UNIT> に従う（例: 円/bbl）
   *
   * @generated from field: double base_curve_price = 4;
   */
  baseCurvePrice: number;

  /**
   * 数量1単位あたりの日次PnL系列。sample_dates と同一行軸・同一整列
   *
   * @generated from field: repeated double daily_pnl_per_unit = 5;
   */
  dailyPnlPerUnit: number[];
};

/**
 * Describes the message devtool.emodel.v1.SymbolMonthSeriesDetail.
 * Use `create(SymbolMonthSeriesDetailSchema)` to create a new message.
 */
export const SymbolMonthSeriesDetailSchema: GenMessage<SymbolMonthSeriesDetail> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 30);

/**
 * Step 2: JEPX調整リクエスト
 *
 * @generated from message devtool.emodel.v1.CalculateJepxAdjustmentRequest
 */
export type CalculateJepxAdjustmentRequest = Message<"devtool.emodel.v1.CalculateJepxAdjustmentRequest"> & {
  /**
   * @generated from field: devtool.emodel.v1.PnLStepResult pnl_result = 1;
   */
  pnlResult?: PnLStepResult;

  /**
   * @generated from field: repeated double daily_mtms = 2;
   */
  dailyMtms: number[];

  /**
   * @generated from field: devtool.emodel.v1.RiskCalcPricingConfig pricing_config = 3;
   */
  pricingConfig?: RiskCalcPricingConfig;

  /**
   * Floating合算用（floating存在時のみ必要）
   *
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_fixed_power_costs = 4;
   */
  dailyFixedPowerCosts: DailyPowerCostEntry[];

  /**
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_unfixed_power_costs = 5;
   */
  dailyUnfixedPowerCosts: DailyPowerCostEntry[];

  /**
   * @generated from field: repeated double daily_jepx_difference_costs = 6;
   */
  dailyJepxDifferenceCosts: number[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateJepxAdjustmentRequest.
 * Use `create(CalculateJepxAdjustmentRequestSchema)` to create a new message.
 */
export const CalculateJepxAdjustmentRequestSchema: GenMessage<CalculateJepxAdjustmentRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 31);

/**
 * Step 2: JEPX調整レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculateJepxAdjustmentResponse
 */
export type CalculateJepxAdjustmentResponse = Message<"devtool.emodel.v1.CalculateJepxAdjustmentResponse"> & {
  /**
   * @generated from field: devtool.emodel.v1.JepxAdjustmentResult result = 1;
   */
  result?: JepxAdjustmentResult;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * @generated from field: int32 runtime_ms = 3;
   */
  runtimeMs: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateJepxAdjustmentResponse.
 * Use `create(CalculateJepxAdjustmentResponseSchema)` to create a new message.
 */
export const CalculateJepxAdjustmentResponseSchema: GenMessage<CalculateJepxAdjustmentResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 32);

/**
 * Step 3: PFE Distribution計算リクエスト
 *
 * @generated from message devtool.emodel.v1.CalculatePFEDistributionRequest
 */
export type CalculatePFEDistributionRequest = Message<"devtool.emodel.v1.CalculatePFEDistributionRequest"> & {
  /**
   * @generated from field: devtool.emodel.v1.JepxAdjustmentResult jepx_result = 1;
   */
  jepxResult?: JepxAdjustmentResult;

  /**
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_fixed_power_costs = 2;
   */
  dailyFixedPowerCosts: DailyPowerCostEntry[];

  /**
   * @generated from field: repeated devtool.emodel.v1.DailyPowerCostEntry daily_unfixed_power_costs = 3;
   */
  dailyUnfixedPowerCosts: DailyPowerCostEntry[];

  /**
   * @generated from field: repeated double daily_jepx_difference_costs = 4;
   */
  dailyJepxDifferenceCosts: number[];

  /**
   * @generated from field: repeated double daily_cash_ios = 5;
   */
  dailyCashIos: number[];

  /**
   * @generated from field: repeated double daily_mtms = 6;
   */
  dailyMtms: number[];

  /**
   * @generated from field: optional devtool.emodel.v1.CollateralConfig collateral = 7;
   */
  collateral?: CollateralConfig;

  /**
   * @generated from field: google.type.Date base_date = 8;
   */
  baseDate?: Date;

  /**
   * @generated from field: repeated int32 selected_percentiles_bps = 9;
   */
  selectedPercentilesBps: number[];

  /**
   * @generated from field: devtool.emodel.v1.RiskCalcOutputConfig output_config = 10;
   */
  outputConfig?: RiskCalcOutputConfig;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePFEDistributionRequest.
 * Use `create(CalculatePFEDistributionRequestSchema)` to create a new message.
 */
export const CalculatePFEDistributionRequestSchema: GenMessage<CalculatePFEDistributionRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 33);

/**
 * Step 3: PFE Distribution計算レスポンス
 *
 * @generated from message devtool.emodel.v1.CalculatePFEDistributionResponse
 */
export type CalculatePFEDistributionResponse = Message<"devtool.emodel.v1.CalculatePFEDistributionResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.SIMResultAndDetail sim_results = 1;
   */
  simResults: SIMResultAndDetail[];

  /**
   * @generated from field: optional devtool.emodel.v1.CalculatePFEMatrices pfe_matrices = 2;
   */
  pfeMatrices?: CalculatePFEMatrices;

  /**
   * @generated from field: optional devtool.emodel.v1.DistributionMatrices distribution_matrices = 3;
   */
  distributionMatrices?: DistributionMatrices;

  /**
   * @generated from field: optional devtool.emodel.v1.SelectedDistributionMatrices selected_distribution_matrices = 4;
   */
  selectedDistributionMatrices?: SelectedDistributionMatrices;

  /**
   * @generated from field: string request_id = 5;
   */
  requestId: string;

  /**
   * @generated from field: int32 runtime_ms = 6;
   */
  runtimeMs: number;

  /**
   * @generated from field: int32 evaluation_days = 7;
   */
  evaluationDays: number;

  /**
   * @generated from field: int32 evaluation_data_count = 8;
   */
  evaluationDataCount: number;

  /**
   * Deprecated: CalculatePnL v2 経由では常に 0（Step1 が current MTM を
   * 計算しなくなったため）。当日MTMは caller 側で計算する。
   *
   * @generated from field: double floating_current_mtm = 10 [deprecated = true];
   * @deprecated
   */
  floatingCurrentMtm: number;

  /**
   * Deprecated: 同上（常に空）。
   *
   * @generated from field: repeated double floating_current_mtm_by_position = 11 [deprecated = true];
   * @deprecated
   */
  floatingCurrentMtmByPosition: number[];
};

/**
 * Describes the message devtool.emodel.v1.CalculatePFEDistributionResponse.
 * Use `create(CalculatePFEDistributionResponseSchema)` to create a new message.
 */
export const CalculatePFEDistributionResponseSchema: GenMessage<CalculatePFEDistributionResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 34);

/**
 * トランザクション単位の入力データ
 *
 * @generated from message devtool.emodel.v1.PFETransaction
 */
export type PFETransaction = Message<"devtool.emodel.v1.PFETransaction"> & {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId: string;

  /**
   * @generated from field: int32 area_code = 2;
   */
  areaCode: number;

  /**
   * @generated from field: string hour_type = 3;
   */
  hourType: string;

  /**
   * @generated from field: string delivery_type = 4;
   */
  deliveryType: string;

  /**
   * @generated from field: string position = 5;
   */
  position: string;

  /**
   * @generated from field: double volume_kw = 6;
   */
  volumeKw: number;

  /**
   * @generated from field: double unit_price_per_kwh = 7;
   */
  unitPricePerKwh: number;

  /**
   * @generated from field: google.type.Date delivery_start = 8;
   */
  deliveryStart?: Date;

  /**
   * @generated from field: google.type.Date delivery_end = 9;
   */
  deliveryEnd?: Date;

  /**
   * @generated from field: optional google.type.Date settled_until = 10;
   */
  settledUntil?: Date;

  /**
   * @generated from field: repeated devtool.emodel.v1.PFEDeliveryTerm delivery_terms = 11;
   */
  deliveryTerms: PFEDeliveryTerm[];
};

/**
 * Describes the message devtool.emodel.v1.PFETransaction.
 * Use `create(PFETransactionSchema)` to create a new message.
 */
export const PFETransactionSchema: GenMessage<PFETransaction> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 35);

/**
 * デリバリータームごとの詳細
 *
 * @generated from message devtool.emodel.v1.PFEDeliveryTerm
 */
export type PFEDeliveryTerm = Message<"devtool.emodel.v1.PFEDeliveryTerm"> & {
  /**
   * @generated from field: google.type.Date start = 1;
   */
  start?: Date;

  /**
   * @generated from field: google.type.Date end = 2;
   */
  end?: Date;

  /**
   * @generated from field: int32 daily_frames = 3;
   */
  dailyFrames: number;
};

/**
 * Describes the message devtool.emodel.v1.PFEDeliveryTerm.
 * Use `create(PFEDeliveryTermSchema)` to create a new message.
 */
export const PFEDeliveryTermSchema: GenMessage<PFEDeliveryTerm> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 36);

/**
 * 支払日マッピング (月初日 → 支払日)
 *
 * @generated from message devtool.emodel.v1.PaymentDateEntry
 */
export type PaymentDateEntry = Message<"devtool.emodel.v1.PaymentDateEntry"> & {
  /**
   * @generated from field: google.type.Date month = 1;
   */
  month?: Date;

  /**
   * @generated from field: google.type.Date payment_date = 2;
   */
  paymentDate?: Date;
};

/**
 * Describes the message devtool.emodel.v1.PaymentDateEntry.
 * Use `create(PaymentDateEntrySchema)` to create a new message.
 */
export const PaymentDateEntrySchema: GenMessage<PaymentDateEntry> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 37);

/**
 * トランザクションからの自動データ準備設定
 *
 * @generated from message devtool.emodel.v1.PFEDataPrepConfig
 */
export type PFEDataPrepConfig = Message<"devtool.emodel.v1.PFEDataPrepConfig"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.PFETransaction transactions = 1;
   */
  transactions: PFETransaction[];

  /**
   * @generated from field: repeated devtool.emodel.v1.PaymentDateEntry payment_dates = 2;
   */
  paymentDates: PaymentDateEntry[];

  /**
   * @generated from field: bool should_reconcile_from_deposit = 3;
   */
  shouldReconcileFromDeposit: boolean;

  /**
   * @generated from field: bool use_payment_date_drop = 4;
   */
  usePaymentDateDrop: boolean;

  /**
   * @generated from field: int32 requested_evaluation_days = 5;
   */
  requestedEvaluationDays: number;
};

/**
 * Describes the message devtool.emodel.v1.PFEDataPrepConfig.
 * Use `create(PFEDataPrepConfigSchema)` to create a new message.
 */
export const PFEDataPrepConfigSchema: GenMessage<PFEDataPrepConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_risk_calc_engine_model, 38);

/**
 * シナリオ一本線分解の対象シナリオを結果ベースで選ぶ基準。
 * PEAK_WITNESS は選択した各 percentile ごとに1シナリオ解決される。
 *
 * @generated from enum devtool.emodel.v1.PFEScenarioSelector
 */
export enum PFEScenarioSelector {
  /**
   * @generated from enum value: PFE_SCENARIO_SELECTOR_UNSPECIFIED = 0;
   */
  PFE_SCENARIO_SELECTOR_UNSPECIFIED = 0,

  /**
   * 最終系列の分位点カーブ（cashIO 控除後）のピーク日を叩いた witness シナリオ
   * （selected_percentiles_bps の各 percentile ごと）
   *
   * @generated from enum value: PFE_SCENARIO_SELECTOR_PEAK_WITNESS = 1;
   */
  PFE_SCENARIO_SELECTOR_PEAK_WITNESS = 1,

  /**
   * シナリオごとの最終パス（cashIO 控除後）のピークが最大のシナリオ
   *
   * @generated from enum value: PFE_SCENARIO_SELECTOR_MAX_PEAK = 2;
   */
  PFE_SCENARIO_SELECTOR_MAX_PEAK = 2,

  /**
   * 同ピークの中央値（nearest-rank、タイ = index 最小）のシナリオ
   *
   * @generated from enum value: PFE_SCENARIO_SELECTOR_MEDIAN_PEAK = 3;
   */
  PFE_SCENARIO_SELECTOR_MEDIAN_PEAK = 3,

  /**
   * 同ピークが最小のシナリオ
   *
   * @generated from enum value: PFE_SCENARIO_SELECTOR_MIN_PEAK = 4;
   */
  PFE_SCENARIO_SELECTOR_MIN_PEAK = 4,
}

/**
 * Describes the enum devtool.emodel.v1.PFEScenarioSelector.
 */
export const PFEScenarioSelectorSchema: GenEnum<PFEScenarioSelector> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_model, 0);

/**
 * 結果詳細レベル
 *
 * @generated from enum devtool.emodel.v1.RiskCalcResultDetailLevel
 */
export enum RiskCalcResultDetailLevel {
  /**
   * @generated from enum value: RISK_CALC_RESULT_DETAIL_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * サマリーのみ（SIMResultのみ）
   *
   * @generated from enum value: RISK_CALC_RESULT_DETAIL_LEVEL_SUMMARY = 1;
   */
  SUMMARY = 1,

  /**
   * 詳細（選択済み分布行列含む）
   *
   * @generated from enum value: RISK_CALC_RESULT_DETAIL_LEVEL_DETAILED = 2;
   */
  DETAILED = 2,

  /**
   * 全行列（CalculatePFEResult、DistributionMatrix含む）
   *
   * @generated from enum value: RISK_CALC_RESULT_DETAIL_LEVEL_FULL_MATRICES = 3;
   */
  FULL_MATRICES = 3,
}

/**
 * Describes the enum devtool.emodel.v1.RiskCalcResultDetailLevel.
 */
export const RiskCalcResultDetailLevelSchema: GenEnum<RiskCalcResultDetailLevel> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_model, 1);

/**
 * 結果タイプ（Go pfetypes.ResultType 相当）
 *
 * @generated from enum devtool.emodel.v1.RiskCalcResultType
 */
export enum RiskCalcResultType {
  /**
   * @generated from enum value: RISK_CALC_RESULT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MTMなし
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_NO_MTM = 1;
   */
  NO_MTM = 1,

  /**
   * MTMあり
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_MTM = 2;
   */
  MTM = 2,

  /**
   * JEPX
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_JEPX = 3;
   */
  JEPX = 3,

  /**
   * MTM + 電力コスト
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_MTM_WITH_POWER = 4;
   */
  MTM_WITH_POWER = 4,

  /**
   * 流動性PFE
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_LIQUIDITY_PFE = 5;
   */
  LIQUIDITY_PFE = 5,

  /**
   * 電力+Floating合算 MTM + 電力コスト (pfetypes.ResultTypeCombinedMTMWithPower = 6)
   *
   * @generated from enum value: RISK_CALC_RESULT_TYPE_COMBINED_MTM_WITH_POWER = 6;
   */
  COMBINED_MTM_WITH_POWER = 6,
}

/**
 * Describes the enum devtool.emodel.v1.RiskCalcResultType.
 */
export const RiskCalcResultTypeSchema: GenEnum<RiskCalcResultType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_risk_calc_engine_model, 2);

